// Isolado num módulo próprio para os testes conseguirem substituir a navegação.
export function redirectTo(url) {
  window.location.assign(url);
}
